export default __webpack_public_path__ + "static/media/mark-finn.fd2fd1dd.jpg";